/* Orient Tech — Homepage redesign layer (reveal-on-scroll for homepage bands)
   Loads ONLY on the homepage, after orient-enhancements.js.

   Safety model mirrors orient-enhancements.js: we only ever HIDE content
   (via the .orient-reveal start state, gated by html.orient-reveal-ready) when
   IntersectionObserver is supported AND the user has not requested reduced
   motion. If JS is off / unsupported / reduced-motion, nothing is hidden.

   This tags the major homepage sections with `.orient-reveal` so they fade up
   as they enter the viewport, then observes them with its own observer (so it
   does not depend on orient-enhancements.js init timing). Both observers only
   add the idempotent `.is-visible` class, so any overlap is harmless. */
(function () {
  "use strict";

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReduced || !("IntersectionObserver" in window)) return;

  function init() {
    var root =
      document.getElementById("MainContent") ||
      document.querySelector("main");
    if (!root) return;

    var sections = root.querySelectorAll(":scope > .shopify-section");
    if (!sections.length) {
      sections = root.querySelectorAll(".shopify-section");
    }

    var tagged = [];
    sections.forEach(function (section) {
      /* Skip the hero (slideshow — above the fold, has its own motion), the
         finder card, and the dark trust ticker (slim, near the top). */
      if (
        section.querySelector(".slideshow") ||
        section.querySelector(".section-filters-wrapper") ||
        section.querySelector(".section-scrolling-elements-wrapper")
      ) {
        return;
      }
      /* Don't double-wrap sections that already opt into reveal internally. */
      if (section.classList.contains("orient-reveal")) return;

      section.classList.add("orient-reveal");
      tagged.push(section);
    });

    if (!tagged.length) return;

    /* Enable the hide-then-reveal CSS now that we know motion is allowed. */
    document.documentElement.classList.add("orient-reveal-ready");

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.08 }
    );

    tagged.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
